<template>
  <div id="page-file-samae" class="full-height">
    <q-card class="q-px-sm">
      <q-card-section class="row fit q-py-xs">
        <crud-layout-search
          ref="crudLayoutSearch"
          :name="params.label"
          :stateKey="params.label"
          :interface="nmInterface"
          :params="params"
          :id="id"
          :maximized="true"
          clean-layout
          :page="page"
          :pageDetail="page"
        >
          <page-table
            slot="page-table"
            slot-scope="dataPageTable"
            v-bind="dataPageTable"
            @action-button="dataPageTable.actionButton"
            @show-message="dataPageTable.showMessage"
          >
            <template slot="table" slot-scope="dataTable">
              <div class="row">
                <div
                  class="col-12"
                  style="padding-left: 50px; margin-top: 20px"
                >
                  <div
                    v-for="state in stateSamaes"
                    :key="state.id"
                    :style="
                      'background-color:' +
                      stateSamae[state.chCodigo].cor +
                      '; margin:3px; padding: 5px 30px; float: left; border-radius: 10px;'
                    "
                  >
                    {{ state.nmDescricao }}
                  </div>
                </div>
                <jt-data-table
                  v-bind="dataTable"
                  virtual-scroll
                  singleselect
                  class="col-12 table-crud"
                  row-buttons
                  ref="jtDataTable"
                  @selection="dataTable.selection"
                  @action-button="dataTable.actionButton"
                  @show-message="dataTable.showMessage"
                  @toggle-change="row"
                >
                  <template v-slot:header="{ props }">
                    <q-tr>
                      <q-th auto-width> </q-th>
                      <q-th
                        v-for="col in props.cols"
                        :key="col.name"
                        :props="props"
                      >
                        {{ col.label }}
                      </q-th>
                      <q-th style="width: 1px" />
                    </q-tr>
                  </template>
                  <template v-slot:body="{ props }">
                    <q-tr>
                      <q-td v-if="props" auto-width>
                        <q-td
                          style="width: 1px"
                          v-if="dataTable.buttons.length > 0"
                          nowrap
                        >
                          <span class="buttons-row">
                            <span
                              v-for="(button, index) in dataTable.buttons"
                              :key="index"
                              :class="button.name"
                            >
                              <q-btn
                                flat
                                small
                                :class="button.name + '-btn protocol-close'"
                                color="primary"
                                :disable="
                                  button.name != 'icDetalhar' &&
                                  props.row['adjusted']
                                "
                                @click="actionButton(button, props.row)"
                              >
                                <q-icon
                                  :name="iconAction(button)"
                                  size="22px"
                                />
                                <q-tooltip>{{ button.label }}</q-tooltip>
                              </q-btn>
                            </span>
                          </span>
                        </q-td>
                      </q-td>
                      <q-td
                        v-for="col in props.cols"
                        :key="col.name"
                        :props="props"
                        :class="availableStyle({ col: col, props: props })"
                        @click="onClickRow({ col: col, props: props })"
                      >
                        <q-tooltip v-if="col.tooltip">
                          {{ tooltip(col, props.row) }}
                        </q-tooltip>
                        <span v-else-if="col.name == 'adjusted'">
                          <q-icon
                            v-if="props.row[col.name]"
                            name="account_circle"
                            color="green"
                            size="2.2em"
                          >
                            <q-tooltip><translate>ANALYZED</translate></q-tooltip>
                          </q-icon>
                          <q-icon
                            v-else-if="props.row['user']"
                            name="account_circle"
                            size="2em"
                            color="blue"
                          >
                            <q-tooltip
                              ><translate>RESPONSIBLE</translate>: {{ props.row["user"] }}</q-tooltip
                            >
                          </q-icon>
                          <q-icon
                            v-else
                            name="account_circle"
                            size="2em"
                            color="red"
                          >
                            <q-tooltip><translate>WAITING_FOR_ANALYSIS</translate></q-tooltip>
                          </q-icon>
                        </span>
                        <span v-else-if="col.name == 'unitStateSamae'">
                          <div
                            v-for="state in jsonState(props.row[col.name])"
                            :key="state.id"
                            :style="
                              'background-color:' +
                              stateSamae[state.chCodigo].cor +
                              '; margin:3px; padding: 3px; border-radius: 10px;'
                            "
                          >
                            {{ state.nmDescricao }}
                          </div>
                        </span>
                        <span v-else>
                          {{ formatedValue(col) }}
                        </span>
                      </q-td>
                    </q-tr>
                  </template>
                </jt-data-table>
              </div>
            </template>
          </page-table>
        </crud-layout-search>
      </q-card-section>
    </q-card>
    <q-dialog v-model="modalUnitStateSamae.show" persistent>
      <q-card style="min-width: 650px;">
        <q-bar class="bg-primary text-white" v-touch-pan.mouse="onPan">
          <div><translate>CLIENT_CHANGE</translate></div>
          <q-space></q-space>
          <q-btn dense flat icon="close" v-close-popup></q-btn>
        </q-bar>
        <q-card-section>
          <div v-if="!modalUnitStateSamae.disableUnit"  class="text-h6">{{ modalUnitStateSamae.message }}</div>
          <div v-else align="center" class="text-h6">{{ $gettext('CHANGE_UNITY') }} </div>

        </q-card-section>

        <q-card-section v-if="!modalUnitStateSamae.disableUnit" class="q-pt-none">
          <q-input
            placeholder="Observação"
            dense
            v-model="modalUnitStateSamae.observation"
            autofocus
          />
          <b style="font-size: 10px; color: rgb(129, 55, 55)"
            >*<translate>OBSERVATION_IS_MANDATORY</translate></b
          >
          <div class="text-center font-bold underline"><translate>CLIENT_CHAGE_DATE</translate>: {{ fluxEntryDate }}</div>
        </q-card-section>
        <q-card-section v-else class="q-pt-none">
            <jt-dynamic-form
            ref="jtDynamicForm"
            :inputs="formsDisabled.inputs"
            :interface="formsDisabled.nmInterface"
            :relacionamentos="formsDisabled.relacionamentos"
            :model="formsDisabled.dadosForm"
            :buttons="formsDisabled.buttons"
            form-class="form"
            />
        </q-card-section>
        <q-card-actions :align="modalUnitStateSamae.disableUnit ?  'center' : 'right'" class="text-primary">
          <q-btn v-if="!modalUnitStateSamae.disableUnit" flat :label="$gettext('CANCEL')" v-close-popup />
          <q-btn v-else  color="grey-7" :label="$gettext('CANCEL')" v-close-popup>
        </q-btn>
        <span v-if="!modalUnitStateSamae.disableUnit">
            <q-btn
            :disabled="!!!modalUnitStateSamae.observation"
            v-if="modalUnitStateSamae.clickNo"
            flat
            :label="$gettext('NO')"
            v-close-popup
            @click="modalUnitStateSamae.clickNo"
          />
          <q-btn
            :disabled="!!!modalUnitStateSamae.observation"
            flat
            :label="$gettext('YES')"
            v-close-popup
            @click="modalUnitStateSamae.click"
          />
        </span>
        <q-btn v-else
          color="info"
          @click="alterPaymentType"
        >
          {{ $gettext('CHANGE') }}
        </q-btn>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable, JtDynamicForm } from 'jtech-webcomps'
import SamaeController from '../SamaeController'
const { CrudLayoutSearch, pageTable } = JtCrud
import pageDetail from './PageDetail'
import unitStateSamae from '../UnitStateSamae.config.js'
import consumerUnitPage from 'src/modules/consumer-unit/ConsumerUnitPage.vue'
import { messageBox } from 'src/jtech/jtech-messagebox'
@Component({
  mixins: [JtDataTable],
  name: 'pageFile',
  components: {
    CrudLayoutSearch,
    pageTable,
    JtDataTable,
    JtDynamicForm,
    consumerUnitPage
  },
  props: {
    params: { type: Object, required: true },
    name: String,
    id: String,
    page: String,
    label: String,
    labelPage: String,
    parent: Object
  }
})
class PageFile extends Vue {
  controller = SamaeController.getInstance();
  nmInterface = 'samae.pesquisarUnits';
  stateSamae = unitStateSamae;
  stateSamaes = [];
  modalUnitStateSamae = {
    params: null,
    show: false,
    message: null,
    observation: '',
    disableUnit: false
  };

  fluxEntryDate = null;

  codeMapping = {
    50230001: {
      name: 'CLIENT_CHANGE',
      showModal: true,
      message: this.$gettext('UNIT_CONSUMER_WILL_BE_CHANGED'),
      setObservation: true,
      doNotApply: true,
      unitDisabled: false
    },
    50230002: {
      name: 'UNIT_NEW',
      showAction: true
    },
    50230003: {
      name: 'UNIT_DISABLED',
      showModal: true,
      message: this.$gettext('CONFIRM_ADJUSTMENT_UNIT_CONSUMER'),
      setObservation: true,
      doNotApply: false,
      unitDisabled: true
    },
    50230004: {
      name: 'UNIT_SUPPRESSED',
      showModal: true,
      message: this.$gettext('CONFIRM_ADJUSTMENT_UNIT_CONSUMER'),
      setObservation: true,
      doNotApply: false,
      unitDisabled: true
    }
  }

  get page () {
    return pageDetail
  }

  async created () {
    const { registros } = await this.controller.stateSamaes()
    this.stateSamaes = registros
  }

  async icAlterarUnit ({ button, params, page, controller }) {
    const codeInfo = this.codeMapping[params.unitStateSamae.find((r) => r.chCodigo).chCodigo]
    if (codeInfo) {
      if (codeInfo.unitDisabled) {
        this.$emit('action-button', button, params, page, controller)
      } else if (codeInfo.showModal) {
        this.setClickButtonAction(codeInfo, button, params, page, controller)
      } else if (codeInfo.showAction) {
        this.$emit('action-button', button, params, page, controller)
      }
    }
  }

  icResponsavelUnit ({ button, params, page, controller }) {
    this.$emit('action-button', button, params, page, controller)
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('icAlterarUnit', this.icAlterarUnit)
      this.$refs.crudLayoutSearch.onButton(
        'icResponsavelUnit',
        this.icResponsavelUnit
      )
    } catch (error) {
      console.error(error)
    }
  }

  setClickButtonAction (codeInfo, button, params, page, controller) {
    this.fluxEntryDate = params.fluxEntryDate || 'N/A'
    this.modalUnitStateSamae.show = true
    this.modalUnitStateSamae.message = codeInfo.message
    this.modalUnitStateSamae.observation = ''

    if (codeInfo.doNotApply !== undefined) {
      this.modalUnitStateSamae.click = () => {
        this.$emit(
          'action-button',
          button,
          {
            ...params,
            observation: this.modalUnitStateSamae.observation,
            doNotApply: codeInfo.doNotApply
          },
          page,
          controller
        )
      }
    } else {
      this.modalUnitStateSamae.click = null
    }
  }

  actionButton (payload, param) {
    param.unitStateSamae = this.jsonState(param.unitStateSamae)
    const id = param.unitStateSamae[0].id
    this.$refs.crudLayoutSearch.actionButton(payload, { ...param, id }, this)
  }

  jsonState (state) {
    if (state instanceof Array) {
      return state
    }
    return JSON.parse(state)
  }
}
export default PageFile
</script>
<style lang="stylus">
@import '~quasar-variables';

.importFileSamaeForms {
  #scroll-area {
    height: calc(20vh - 1px) !important;
  }
}

.table-file-samae {
  .jt-datatable {
    height: 45vh !important;
  }
}

#page-file-samae {
  .table-crud {
    .q-table__control:not(:has(button)) {
      display: none;
    }
  }
}
</style>
